export const GET_USER_OUTPUT_FINISH = 'GET_USER_OUTPUT_FINISH'
export const GET_USER_OUTPUT_START = 'GET_USER_OUTPUT_START'
export const GET_USER_OUTPUT_ERROR = 'GET_USER_OUTPUT_ERROR'
export const ELEGIR_USER_OUTPUT = 'ELEGIR_USER_OUTPUT'
export const TOGGLE_SHOW_CORRECTION = 'TOGGLE_SHOW_CORRECTION'
export const ADD_INDICE_USER_OUTPUT_HISTORY = 'ADD_INDICE_USER_OUTPUT_HISTORY'
export const UPDATE_USER_OUTPUT_COMMENTS = 'UPDATE_USER_OUTPUT_COMMENTS'
export const UPDATE_USER_OUTPUT_LIKE = 'UPDATE_USER_OUTPUT_LIKE'
export const SELECT_OUTPUT_BY_USER_OUTPUT_ID = 'SELECT_OUTPUT_BY_USER_OUTPUT_ID'
